import getWithToken from "./base/get-with-token";

const getNonRevenueWater = getWithToken("/none-revenue-water-zone-balance");

export default getNonRevenueWater;
